import React, { useState, useEffect, useRef} from 'react';
import { useForm } from "react-hook-form";
import { useMutation, queryCache, } from 'react-query';
import Title from "./../Title";
import Input from "./../Input";
import Button from "./../Button";
import ErrorMessages from './../ErrorMessages';
import TicketCodeInput from '../TicketCodeInput';
import requsetErrorMessage from '../../libraries/requsetErrorMessage';
import UserLibrary from '../../libraries/User';
import api from '../../api';

/**
 * ChangeEmail component
 * @param {Object} [props]
 * @param {Function} [props.onClose] - Callback method when cancel button is clicked
 * @component
 */

export default ({
  onClose = () => {},
}) => {

    const { register, handleSubmit,watch, errors } = useForm({ criteriaMode: 'all' });
    const [localErrorMsg, setLocalError] = useState("");
    const codeInput = useRef();
    const [code, setCode] = useState('');
    const newEmail = watch('email');

    const [updateEmail, { isLoading: isUpdateMailLoading, isError: isErrorUpdateMail, error: updateMailError, isSuccess: isSuccessUpdateMail }] = useMutation(api.user.updateEmail);

    const [sendCode, { error: sendingCodeError, isLoading: isSendingCodeLoading }] = useMutation(api.user.sendEmailUpdateCode, {
    onSuccess(userData) {
      codeInput.current.clear();
      queryCache.setQueryData('profile', queryCacheData => ({
        ...queryCacheData,
        data: {
        ...queryCacheData.data,
        ...userData.data,
      }}));
      onClose()
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  const onSubmitHandler = (data) => {
    setLocalError('');
    updateEmail({ email: data.email });
  }

  return (
    <div className="form-container">
      {!isSuccessUpdateMail ? (
        <>
          <Title>Email-Adresse ändern</Title>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <div className="row">
              <Input
                label="E-Mail"
                fullwidth
                nomargin
                disabled={true}
                value={UserLibrary.get("email") || ""}
              />
            </div>

            <div className="row">
              <Input
                label="Neue E-Mail-Adresse*"
                name="email"
                fullwidth={true}
                nomargin={true}
                error={errors.email}
                ref={register({
                  required: "E-Mail ist erforderlich",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Ungültige E-Mail-Adresse",
                  },
                })}
              />
            </div>
            <div className="row">
              <Input
                label="Neue E-Mail-Adresse bestätigen*"
                name="confirm_email"
                fullwidth={true}
                nomargin={true}
                error={errors.confirm_email}
                ref={register({
                  required: "Bitte wiederholen Sie Ihre E-Mail-Adresse",
                  validate: (value) =>
                    value === newEmail ||
                    "E-Mail-Adressen stimmen nicht überein",
                })}
              />
            </div>
            {errors.confirm_email && (
              <ErrorMessages messages={[errors.confirm_email.message]} />
            )}
            {isErrorUpdateMail && (
              <div className="ErrorMessagesWrapper">
                <ErrorMessages
                  messages={requsetErrorMessage(
                    !!updateMailError?.data?.message
                      ? updateMailError.data.message
                      : ""
                  )}
                />
              </div>
            )}
            {localErrorMsg && <ErrorMessages messages={localErrorMsg} />}

            <div className="row">
              <Button
                type="submit"
                loading={isUpdateMailLoading}
                disabled={isUpdateMailLoading}
              >
                Email-Adresse ändern
              </Button>
              <Button
                disabled={isUpdateMailLoading}
                onClick={onClose}
                theme="gray"
              >
                Abbrechen
              </Button>
            </div>
          </form>
        </>
      ) : (
        <div className="as-form">
          <Title>Code eingeben</Title>
          <Title small>
            Wir haben dir einen Code an deine neue E-Mail-Adresse geschickt.
            Bitte gib diesen zur Bestätigung hier ein.
          </Title>

          <TicketCodeInput
            ref={codeInput}
            onChange={setCode}
            length={4}
            groupSize={4}
            style={{ transformOrigin: 'top left', transform: 'scale(1.6)' }}
          />

          {!!sendingCodeError?.data?.message && (
            <ErrorMessages
              messages={requsetErrorMessage(sendingCodeError.data.message)}
            />
          )}

          <Button
            fullwidth
            margin="top"
            disabled={code.length !== 4}
            loading={isSendingCodeLoading}
            onClick={() => sendCode({ code })}
          >
            Senden
          </Button>
        </div>
      )}
    </div>
  );
};